module.exports = __webpack_public_path__ + "static/img/logo.406879d3.png";